import React from 'react';
import PropTypes from 'prop-types';
import css from './CwColorPalette.scss';

class CwColorPalette extends React.Component{

  handleClick = (color) => {
    if (this.props.onClick)
      this.props.onClick(color);
  };

  handleMouseDown = () => {
    if (this.props.onMouseDown)
      this.props.onMouseDown(true);
  };

  renderSwatch (color) {
    return (
      <div 
        key={color.name} 
        data-cwid={this.props.cwId + '_' + color.id}
        style={{backgroundColor: color.id}} 
        className={css.swatch}
        onClick={() => {this.handleClick(color);}}
        onMouseDown={this.handleMouseDown}
      />
    );
  }

  renderSwatchRow(id, swatches) {
    return (
      <div key={id}>
        {swatches}
      </div>
    );
  }

  render () {
    const colors = this.props.colors;
    let swatches = [];
    const swatchRows = [];
    const rowLength = 4;

    // Create grid of swatches
    for (let n = 1; n <= colors.length; n++) {
      swatches.push(this.renderSwatch(colors[n-1]));
      if (n % rowLength === 0 || n === colors.length) { // Add a new row when rowLength reached
        swatchRows.push(this.renderSwatchRow(n, swatches));
        swatches = [];
      }
    }

    return (
      <div data-cwid={this.props.cwId} className={css.colorPalette} style={this.props.style}>
        {swatchRows}
      </div>
    );
  }
}

CwColorPalette.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: PropTypes.func,
  /**
   * Array of colors to be displayed in the color palette. "id" must be equal to the hex of the color. "name" is the text displayed in the trigger field.
   */
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),

  /**
   * Set of style properties to determine the palette's position. Must contain left and top
   */
  style: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }),
};

export default CwColorPalette;


// WEBPACK FOOTER //
// ./src/components/cwcolorfield/CwColorPalette.jsx